<customer-select class="mx:hidden sm:block sm:w-full"></customer-select>
<div class="contract__container">
  <div class="contract-history__tabs">
    <nz-tabset [(nzSelectedIndex)]="tabSelectedIndex" [nzTabBarExtraContent]="extraTemplate">
      <nz-tab [nzTitle]="'MARKETING_PROCESS_COST'| translate">
        <ng-template nz-tab>
          <app-marketing-activity-cost [tabSelectedIndex]="tabSelectedIndex"></app-marketing-activity-cost>
        </ng-template>
      </nz-tab>
      <nz-tab [nzTitle]="'MARKETING_PROCESS_MATERIAL'| translate">
        <ng-template nz-tab>
          <app-marketing-activity-material [tabSelectedIndex]="tabSelectedIndex"></app-marketing-activity-material>
        </ng-template>
      </nz-tab>
    </nz-tabset>
    <ng-template #extraTemplate>
      <customer-select class="sm:hidden mx:block"></customer-select>
    </ng-template>
  </div>
</div>